import { useVistaFeatureFlag } from '@99designs/experiments';

export function useChatBriefFeatureFlag(esMpvId: string) {
    return useVistaFeatureFlag('design_services_chat_brief', [
        { value: esMpvId.toLowerCase(), must: 'businesscarddesign' },
    ]);
}
